/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prescription_Reason_Agent_ProgressingInputs */

const en_us2_prescription_reason_agent_progressing = /** @type {(inputs: Prescription_Reason_Agent_ProgressingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are progressing on it, so it stays`)
};

const pt_br2_prescription_reason_agent_progressing = /** @type {(inputs: Prescription_Reason_Agent_ProgressingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você está evoluindo nele, então ele fica`)
};

const es_419_prescription_reason_agent_progressing = /** @type {(inputs: Prescription_Reason_Agent_ProgressingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estás progresando en él, así que se queda`)
};

const pt_pt2_prescription_reason_agent_progressing = /** @type {(inputs: Prescription_Reason_Agent_ProgressingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estás a evoluir nele, por isso fica`)
};

const fr_fr2_prescription_reason_agent_progressing = /** @type {(inputs: Prescription_Reason_Agent_ProgressingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu progresses dessus, donc il reste`)
};

const de_de2_prescription_reason_agent_progressing = /** @type {(inputs: Prescription_Reason_Agent_ProgressingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du machst hier Fortschritte, also bleibt sie`)
};

const it_it2_prescription_reason_agent_progressing = /** @type {(inputs: Prescription_Reason_Agent_ProgressingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stai progredendo, quindi resta`)
};

/**
* | output |
* | --- |
* | "You are progressing on it, so it stays" |
*
* @param {Prescription_Reason_Agent_ProgressingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_reason_agent_progressing = /** @type {((inputs?: Prescription_Reason_Agent_ProgressingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Reason_Agent_ProgressingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_reason_agent_progressing(inputs)
	if (locale === "es-419") return es_419_prescription_reason_agent_progressing(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_reason_agent_progressing(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_reason_agent_progressing(inputs)
	if (locale === "de-DE") return de_de2_prescription_reason_agent_progressing(inputs)
	if (locale === "it-IT") return it_it2_prescription_reason_agent_progressing(inputs)
	return en_us2_prescription_reason_agent_progressing(inputs)
});
export { prescription_reason_agent_progressing as "prescription.reason.agent_progressing" }